import { createSelector } from '@ngrx/store';
import { getHistoryOrderStatus } from '../getHistoryOrderStatus';

export const isHistoryOrderAtSite = (orderId: number) =>
    createSelector(
        getHistoryOrderStatus(orderId),
        (status) => status === OLO.Enums.ONLINE_ORDER_STATUS.SENT_TO_SITE || status === OLO.Enums.ONLINE_ORDER_STATUS.RECIVED_AT_SITE
    );
